var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInputPreviewCp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04236 2.5613V1.59126C1.04236 1.26471 1.30707 1 1.63362 1H2.33182M1.04236 5.29817V7.2499M4.19379 1H5.42763M1.04236 9.89699V10.8939C1.04236 11.2205 1.30707 11.4852 1.63362 11.4852H2.46642M7.37933 1H8.04847C8.25618 1 8.44869 1.10901 8.55554 1.28715L9.08921 2.17697",
    stroke: "#696969",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94721 14H11.4937C12.1467 14 12.6762 13.4705 12.6762 12.8175V6.20457C12.6761 5.99972 12.5948 5.80328 12.45 5.65839L10.9701 4.17855C10.8252 4.03375 10.6288 3.9524 10.4239 3.95235H4.94721C4.74224 3.95235 4.54565 4.03378 4.4007 4.17873C4.25575 4.32367 4.17432 4.52026 4.17432 4.72525V13.2271C4.17432 13.4321 4.25575 13.6286 4.4007 13.7736C4.54565 13.9185 4.74224 14 4.94721 14Z",
    stroke: "#696969",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputPreviewCp);
export default __webpack_public_path__ + "static/media/input-preview-cp.ef1ece922adcfe879794af95f94faacd.svg";
export { ForwardRef as ReactComponent };